export const MONTH_SHORT_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTH_LONG_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const ALL_MONTHS = "all";

export const toSafeNumber = (value) => Number(value || 0);

export const formatCompactNumber = (value) =>
  toSafeNumber(value).toLocaleString("en-IN");

export const toDateValue = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getAvailableYears = (values = []) =>
  [...new Set(values.map((value) => toDateValue(value)?.getFullYear()).filter(Number.isFinite))].sort(
    (a, b) => b - a
  );

export const getMonthLabel = (monthIndex) =>
  MONTH_LONG_NAMES[monthIndex] || "";

export const getDaysInMonth = (year, monthIndex) =>
  new Date(year, monthIndex + 1, 0).getDate();

export const sumByKey = (items = [], key = "count") =>
  items.reduce((sum, item) => sum + toSafeNumber(item?.[key]), 0);
